import React from "react";
import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";

const PaymentCancel = () => (
  <div className="min-h-screen bg-[#050505] flex flex-col items-center justify-center px-6 text-center">
    <div className="max-w-md w-full bg-[#121212] border border-white/10 rounded-2xl p-10" data-testid="payment-cancel-page">
      <XCircle className="text-white/40 mx-auto mb-5" size={56} />
      <h1 className="font-display text-2xl font-bold text-white">Pagamento annullato</h1>
      <p className="text-white/55 mt-3">
        La prenotazione non è stata completata. Puoi riprovare quando vuoi.
      </p>
      <Link
        to="/"
        data-testid="cancel-home-link"
        className="inline-block mt-8 bg-[#FFF200] text-black font-semibold px-7 py-3 rounded-full hover:bg-[#FFF200]/90 transition-colors"
      >
        Torna alla home
      </Link>
    </div>
  </div>
);

export default PaymentCancel;
